import { render, staticRenderFns } from "./gender-select.vue?vue&type=template&id=b626238a&scoped=true"
import script from "./gender-select.vue?vue&type=script&lang=js"
export * from "./gender-select.vue?vue&type=script&lang=js"
import style0 from "./gender-select.vue?vue&type=style&index=0&id=b626238a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b626238a",
  null
  
)

export default component.exports